import type {Config} from '@/types'
import {ApiService, ResponseData} from './api'

export class AuthService
{

	private readonly apiService: ApiService;
	private readonly auth_domain: string = '';
	private readonly main_path: string = '';

	constructor(apiService: ApiService)
	{
		if (!apiService)
			throw new Error('ApiService не инициализирован');
		if (!apiService.getConfig())
			throw new Error('Отсутствует конфигурация сервера');
		if (!apiService.getConfig().auth_domain)
			throw new Error('Отсутствует Auth-домен в конфигурации сервера');
		this.apiService = apiService;
		this.auth_domain = apiService.getConfig().auth_domain;
		this.main_path = '/main/auth/s';
	}

	// async register(email: string, password: string): Promise<void> {
	// 	try {
	//
	// 		const response = await this.apiService.doFetch(
	// 			this.auth_domain,
	// 			this.main_path + '/signup',
	// 			'POST',
	// 			{email, password}
	// 		);
	//
	// 		const result = await this.apiService.getResponseJson(response);
	//
	// 		if (!result.success) {
	// 			throw {
	// 				message: result.error || 'Ошибка регистрации',
	// 				code: result.response_code || 400,
	// 				fields: result.data && Array.isArray(result.data) ? result.data : undefined
	// 			};
	// 		}
	//
	// 	} catch (error) {
	// 		throw (error instanceof Error)
	// 			? {
	// 				message: error.message,
	// 				code: 500
	// 			}
	// 			: error;
	// 	}
	// }

	async signup(email: string, password: string, confirm_password: string): Promise<ResponseData>
	{
		try {

			const response = await this.apiService.doFetch(
				this.auth_domain,
				this.main_path + '/signup',
				'POST',
				{email, password, confirm_password}
			);

			return await this.apiService.getResponseJson(response);
		} catch (error) {
			return {
				success: false,
				error: error instanceof Error ? error.message : 'Ошибка при регистрации'
			};
		}
	}

	async handleConfirmationEmail(token: string, email: string, action: string): Promise<ResponseData>
	{
		try {

			const response = await this.apiService.doFetch(
				this.auth_domain,
				this.main_path + '/confirm-email?' + new URLSearchParams({
					// token=${token}&email=${email}&action=${action}
					token,
					email,
					action,
				}),
			);

			return await this.apiService.getResponseJson(response);
		} catch (error) {
			return {
				success: false,
				error: error instanceof Error ? error.message : 'Ошибка подтверждения почты'
			};
		}
	}

	// async login(email: string, password: string, rememberMe: boolean = true): Promise<void> // Promise<ResponseData>
	// {
	// 	try {
	//
	// 		const response = await this.apiService.doFetch(
	// 			this.auth_domain,
	// 			this.main_path + '/login',
	// 			'POST',
	// 			{email, password, remember_me: rememberMe}
	// 		);
	//
	// 		const result = await this.apiService.getResponseJson(response);
	//
	// 		if (!result.success) {
	// 			// Создаем объект ошибки с полями для точечной обработки
	// 			throw {
	// 				message: result.error || 'Ошибка авторизации',
	// 				code: result.response_code || 401,
	// 				fields: result.data && Array.isArray(result.data) ? result.data : undefined
	// 			};
	// 		}
	//
	// 		// Дополнительная обработка, если требуется подтверждение email
	// 		if (result.data?.requires_email_confirmation) {
	// 			throw {
	// 				message: 'Требуется подтверждение email',
	// 				code: 403,
	// 				fields: ['email'],
	// 				requiresEmailConfirmation: true
	// 			};
	// 		}
	//
	// 	} catch (error) {
	// 		// return {
	// 		// 	success: false,
	// 		// 	error: error instanceof Error ? error.message : 'Ошибка при авторизации'
	// 		// };
	//
	// 		// Обработка сетевых ошибок и других исключений
	// 		throw (error instanceof Error)
	// 			? {
	// 				message: error.message,
	// 				code: 500
	// 			}
	// 			: error;
	// 	}
	// }

	async login(email: string, password: string, rememberMe: boolean = true): Promise<ResponseData>
	{
		try {

			const response = await this.apiService.doFetch(
				this.auth_domain,
				this.main_path + '/login',
				'POST',
				{email, password, remember_me: rememberMe}
			);

			return await this.apiService.getResponseJson(response);
		} catch (error) {
			return {
				success: false,
				error: error instanceof Error ? error.message : 'Ошибка авторизации'
			};
		}
	}

	async checkAuth(): Promise<boolean>
	{
		return this.apiService.checkAuth();
	}

	async isAuthenticated(): Promise<boolean>
	{
		return this.apiService.checkAuth();
	}

	async logout(): Promise<ResponseData>
	{
		try {

			const response = await this.apiService.doFetch(
				this.auth_domain,
				this.main_path + '/logout'
			);

			const result = await this.apiService.getResponseJson(response);
			if (!result.success)
				throw new Error(result.error || 'Ошибка при выходе');

			this.apiService.clearUserData();
			return result;
		} catch (error) {
			return {
				success: false,
				error: error instanceof Error ? error.message : 'Ошибка при выходе'
			};
		}
	}


	// TODO: новые методы...

	async forgotPassword(email: string): Promise<ResponseData>
	{
		try {

			const response = await this.apiService.doFetch(
				this.auth_domain,
				this.main_path + '/forgot-password',
				'POST',
				{email}
			);

			return await this.apiService.getResponseJson(response);
		} catch (error) {
			return {
				success: false,
				error: error instanceof Error ? error.message : 'Ошибка восстановления пароля'
			};
		}
	}

	async resetPassword(token: string, newPassword: string): Promise<ResponseData>
	{
		try {

			const response = await this.apiService.doFetch(
				this.auth_domain,
				this.main_path + '/reset-password',
				'POST',
				{token, new_password: newPassword}
			);

			return await this.apiService.getResponseJson(response);
		} catch (error) {
			return {
				success: false,
				error: error instanceof Error ? error.message : 'Ошибка сброса пароля'
			};
		}
	}

	async validateResetToken(token: string): Promise<void>
	{
		try {

			const response = await this.apiService.doFetch(
				this.auth_domain,
				this.main_path + '/validate-reset-token',
				'GET',
				{token}
			);

			const result = await this.apiService.getResponseJson(response);
			if (!result.success)
				throw new Error(result.error || 'Недействительный или устаревший токен');

		} catch (error) {
			if (error instanceof Error)
				throw new Error(error.message);
			throw new Error('Произошла ошибка при проверке токена');
		}
	}

	async resendConfirmationEmail(email: string): Promise<void>
	{

		// TODO: временно отключено
		throw new Error('Временно отключено');

		// try {
		//
		// 	const response = await this.apiService.doFetch(
		// 		this.auth_domain,
		// 		this.main_path + '/resend-confirmation',
		// 		'POST',
		// 		{email}
		// 	);
		//
		// 	const result = await this.apiService.getResponseJson(response);
		// 	if (!result.success)
		// 		throw new Error(result.error || 'Ошибка при отправке письма подтверждения');
		//
		// } catch (error) {
		// 	if (error instanceof Error)
		// 		throw new Error(error.message);
		// 	throw new Error('Произошла ошибка при отправке письма');
		// }
	}

	async isEmailConfirmed(): Promise<boolean>
	{

		// TODO: временно отключено
		return false;

		try {

			const response = await this.apiService.doFetch(
				this.auth_domain,
				this.main_path + '/check-confirmation',
				'GET',
				{}
			);

			const result = await this.apiService.getResponseJson(response);

			return (result.success && result.data && result.data.is_confirmed);
		} catch (error) {
			return false;
		}
	}

}